import { number } from 'yup'

export const version = (v: number) => number().oneOf([v]).required()
